import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/image/avatar.png'


const _withScopeId = n => (_pushScopeId("data-v-76d9af60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list pt-20 pb-20 pl-10 pr-10" }
const _hoisted_2 = { class: "list-head" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "avatar",
  src: _imports_0,
  alt: ""
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("登录/注册")
const _hoisted_6 = { class: "user-info ml-10" }
const _hoisted_7 = { class: "name c0 fs-15 fw-500" }
const _hoisted_8 = {
  key: 0,
  class: "tag pt-5 pb-5 c-00B96B fs-10 mt-5"
}
const _hoisted_9 = { class: "topup mt-10" }
const _hoisted_10 = {
  class: "unit c0",
  style: {"display":"flex","align-items":"flex-end","margin-right":"15px"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "fw-600 fs-10",
  style: {"width":"max-content"}
}, "余额￥", -1))
const _hoisted_12 = { class: "price fw-bold fs-20" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("去充值")
const _hoisted_14 = { class: "tool-list mt-35 pointer" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "c9 ml-5 fs-16" }
const _hoisted_18 = { class: "avatar-box" }
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 1,
  class: "avatar",
  src: _imports_0,
  alt: ""
}
const _hoisted_21 = {
  key: 2,
  class: "circle-wrap fromCenter ae-4 done"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle-1" }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle-2" }, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle-3" }, null, -1))
const _hoisted_26 = [
  _hoisted_22,
  _hoisted_23,
  _hoisted_24,
  _hoisted_25
]

import { ref, onMounted, onUnmounted } from "vue";
import avatarListIcon1 from "@/assets/image/avatar-list-1.png";
import avatarListIcon2 from "@/assets/image/avatar-list-2.png";
import avatarListIcon3 from "@/assets/image/avatar-list-3.png";
import avatarListIcon4 from "@/assets/image/avatar-list-4.png";
import avatarListIcon5 from "@/assets/image/avatar-list-5.png";
import avatarListIcon6 from "@/assets/image/avatar-list-6.png";
import avatarListIcon7 from "@/assets/image/avatar-list-7.png";
import avatarListIcon8 from "@/assets/image/avatar-list-8.png";
import request from '@/utils/request';
import { store } from "@/store/index"
import router from "@/router";
// console.log(store.state.userInfo)

export default /*#__PURE__*/_defineComponent({
  setup(__props, { emit }) {

const tooltipVisible = ref<boolean>(false);

const listArr = ref<{ icon: string; name: string; to: string }[]>([
    {
        icon: avatarListIcon1,
        name: '面板首页',
        to: "/my/home",
    },
    {
        icon: avatarListIcon2,
        name: '我的作品',
        to: "/my/works",
    },
    {
        icon: avatarListIcon3,
        name: '我的收益',
        to: "/my/earnings",
    },
    {
        icon: avatarListIcon4,
        name: '我的下载',
        to: "/my/download",
    },
    {
        icon: avatarListIcon8,
        name: '我的支付',
        to: "/my/payment",
    },
    {
        icon: avatarListIcon5,
        name: '我的收藏',
        to: "/my/collect",
    },
    {
        icon: avatarListIcon6,
        name: '账号设置',
        to: "/my/setting",
    },
    {
        icon: avatarListIcon7,
        name: '退出账号',
        to: "logout",
    },
])
const goPage = (url: any) => {
    router.push({
        path: url,
        query: {}
    })
}
const switchRouter = (to: string) => {
    tooltipVisible.value = false;
    if (to === "logout") {
        showConfirm.value = true;

    } else {
        router.push({ path: to })

    }

}
const handleOk = () => {
    request.post('/login/logout').then(res => {
        if (res && res.code === 200) {
            localStorage.clear();
            store.commit("setUserInfo", null)
            router.push({ name: "login" })
        }
    });
}
const topup = () => {
    tooltipVisible.value = false;
    router.push({ name: "rechargePrice" })

}
const visibleChange = (visible: boolean) => {
    if (visible && store.state.userInfo === null) {
        tooltipVisible.value = false;
    }
}
const showConfirm = ref(false);
const doScroll = () => {
    tooltipVisible.value = false
}
onMounted(() => {
    window.addEventListener('scroll', doScroll)
})

onUnmounted(() => {
    window.removeEventListener('scroll', doScroll)
}) 

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_tooltip, {
      placement: "bottomRight",
      visible: tooltipVisible.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (tooltipVisible.value = $event)),
      trigger: "hover",
      color: "#fff",
      onVisibleChange: visibleChange,
      overlayClassName: "diy-select"
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_unref(store).state.userInfo?.id)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_unref(store).state.userInfo?.avatar)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "avatar",
                        src: _unref(store).state.userInfo?.avatar,
                        alt: ""
                      }, null, 8, _hoisted_3))
                    : (_openBlock(), _createElementBlock("img", _hoisted_4))
                ], 64))
              : (_openBlock(), _createBlock(_component_a_button, {
                  key: 1,
                  style: {"width":"100px"},
                  type: "primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (goPage('/login')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                })),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(store).state.userInfo?.realname), 1),
              (_unref(store).state.userInfo?.brandTitle)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(store).state.userInfo?.brandTitle), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(store).state.myBalance?.rechargeAmount), 1)
            ]),
            _createVNode(_component_a_button, {
              type: "primary",
              class: "fs-13",
              size: "small",
              onClick: topup,
              style: {"min-width":"57px","height":"28px","margin-left":"auto"}
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listArr.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "list-item mb-25",
                onClick: ($event: any) => (switchRouter(item.to))
              }, [
                _createElementVNode("img", {
                  class: "icon",
                  src: item.icon,
                  alt: ""
                }, null, 8, _hoisted_16),
                _createElementVNode("span", _hoisted_17, _toDisplayString(item.name), 1)
              ], 8, _hoisted_15))
            }), 256))
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_18, [
          (_unref(store).state.userInfo?.id)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_unref(store).state.userInfo?.avatar)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "avatar",
                      src: _unref(store).state.userInfo?.avatar,
                      alt: ""
                    }, null, 8, _hoisted_19))
                  : (_openBlock(), _createElementBlock("img", _hoisted_20))
              ], 64))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "goLogin-btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (goPage('/login')))
              }, "登录/注册")),
          (_unref(store).state.userInfo?.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_26))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: showConfirm.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (showConfirm.value = $event)),
      width: "380px",
      centered: "",
      title: "确认退出账号？",
      okText: "确认",
      cancelText: "取消",
      onOk: handleOk
    }, null, 8, ["visible"])
  ], 64))
}
}

})